export const SystemDataloggerOverviewEndpoint = {
  GET_SYSTEM_DATA_LOGGER: '/monitoring/system-data-logger/get-system-data-logger',
  GET_SYSTEM_DATA_LOGGER_STATE: '/monitoring/system-data-logger/get-datalogger-state',
  GET_SYSTEM_DATA_LOGGER_AUTH_KEY: '/monitoring/system-data-logger/get-auth-key',
  GET_COMPLETED_TRANSFERS: '/monitoring/system-data-logger/get-completed-transfers',
  GET_CURRENT_REQUEST: '/monitoring/system-data-logger/get-current-request',
  DOWNLOAD_FIlE: '/monitoring/system-data-logger/download-file',
};
